import { render } from "./NewTDACartStageDetails.vue?vue&type=template&id=00f4f98b"
import script from "./NewTDACartStageDetails.vue?vue&type=script&lang=js"
export * from "./NewTDACartStageDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__